import React from 'react'
import './Hero.css'
import { Link } from 'react-router-dom'
import hero_background from '../Assets/JETT BG.jpg'

const Hero = () => {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${hero_background})` }}
    >
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <p className="hero-brand">BADTAMEEZDIL GAMESTORE</p>

        <h1>VALORANT VP</h1>

        <p className="hero-subtitle">
          Your trusted destination for Valorant Points.
          <br />
          Choose your package and level up your game.
        </p>

        <div className="hero-buttons">
          <Link to="/valorant-vp" className="hero-primary-btn">
            VIEW VP PACKAGES
          </Link>

          <Link to="/valorant-accounts" className="hero-secondary-btn">
            VALORANT ACCOUNTS
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Hero